import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, finalize, retry, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { NotificationsService } from '@/shared/notifications/notifications.service';
import { LoaderService } from '@/shared/components/loader/services/loader.service';

export const backendTokenInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const tokenService = inject(TokenService);
  const notificationsService = inject(NotificationsService);
  const loader = inject(LoaderService);
  const router = inject(Router);

  //if (!req.url.includes('/api/maxline/eventos')) {
    loader.show();
//  }

  if (tokenService.hasToken()) {
    const token = tokenService.getToken();
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Accept-Language': 'pt-BR',
      },
    });
  }

  return next(req).pipe(
    retry(0),

    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        tokenService.removeToken();
        router.navigate(['/login']);
        return throwError(() => error);
      }

      if (error.status !== 404) {
        if (!error.error) {
          notificationsService.toastNotify('error', error.statusText, error.message);
        } else if (error.error.objects) {
          console.error(error.error);
          notificationsService.toastNotify(
            'error',
            error.error.title,
            error.error.objects[0].userMessage
          );
        } else if (error.error.detail) {
          console.error(error.error);
          notificationsService.toastNotify('error', error.error.title, error.error.detail);
        } else {
          console.error(error.error);
          const msg =
            typeof error.error === 'string'
              ? error.error
              : `${error.message}: ${error.status}`;
          notificationsService.toastNotify('error', 'Erro!', msg);
        }
      }

      return throwError(() => error);
    }),

    finalize(() => loader.hide())
  );
};
